
import {computed, defineComponent} from "vue";
import CaratSelect from "@/components/CaratSlect.vue";
import PriceSelect from "@/components/PriceSelect.vue";
import ClaritySelect from "@/components/ClaritySelect.vue";
import DiamondShapeSelect from "@/components/DiamandShapeSelect.vue";
import DiamondTable from "@/components/DiamondTable.vue";
import SingleDiamondSelectionSummary from "@/components/SingleDiamondSelectionSummary.vue";
import NoDiamondSelected from "@/components/NoDiamondSelected.vue";
import useStore from "@/composables/useStore";
import ComparableDiamonds from "@/components/ComparableDiamonds.vue";
import DiamondClarityDiagram from "@/components/DiamondClarityDiagram.vue";
import DiamondColorDiagram from "@/components/DiamondColorDiagram.vue";
import DiamondProperties from "@/components/DiamondProperties.vue";
import DiamondImage from "@/components/DiamondImage.vue";
import SelectedDiamondGiaCertificate from "@/components/SelectedDiamondGiaCertificate.vue";
import SelectedDiamondGiaCertificateLink from "@/components/SelectedDiamondGiaCertificateLink.vue";
import BuyButton from "@/components/single-diamond-configurator/BuyButton.vue";
import {useI18n} from "vue-i18n";

export default defineComponent({
    name: "SingleDiamond.vue",
    components: {
        BuyButton,
        SelectedDiamondGiaCertificate,
        SelectedDiamondGiaCertificateLink,
        DiamondImage,
        DiamondProperties,
        DiamondColorDiagram,
        DiamondClarityDiagram,
        ComparableDiamonds,
        NoDiamondSelected,
        SingleDiamondSelectionSummary,
        DiamondTable,
        DiamondShapeSelect,
        ClaritySelect,
        PriceSelect,
        CaratSelect
    },
    setup() {
        const store = useStore();
        const selectedDiamond = computed(
            () => store.state.userSelection.diamond
        );

        return {
            ...useI18n(),
            selectedDiamond
        };
    }
});
